'use strict';
module.exports = require('./lib/index');
